import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ListType } from '@/components/pages/setting/guest-room/key-number'
import { Control, Controller, useFieldArray } from 'react-hook-form'
import { TableHeader, TableBody, TableRow, TableDisabledOverlay } from '@/components/atoms/settings/table'
import { Select } from '@/components/atoms/select'
import { Select as AntSelect } from 'antd'
import { useSmartLockDevices } from '@/hooks/use-smart-lock-devices'
import { AccountInfo, SmartLockDeviceType } from '@/models/lock-setting'

type Props = {
  lockType: SmartLockDeviceType
  accountInfo: AccountInfo | undefined
  control: Control<{ assign: ListType[] }, any>
  onChange: () => void
}

export const SettingSmartLockGuestRoomKeyList: React.FC<Props> = ({ lockType, accountInfo, control, onChange: parentOnChange }) => {
  const { t } = useTranslation()
  const { deviceList } = useSmartLockDevices(lockType, accountInfo)

  const assignForm = useFieldArray({
    control,
    name: 'assign',
  })

  return (
    <>
      <TableHeader>
        <div css={roomTypeWidthStyle}>{t('Room type')}</div>
        <div css={floorNumberWidthStyle}>{t('Number of floors')}</div>
        <div css={roomNameWidthStyle}>{t('Room name')}</div>
        <div css={deviceNameWidthStyle}>{t('Device name')}</div>
      </TableHeader>
      <TableBody>
        {!accountInfo?.isConnected && <TableDisabledOverlay />}
        {assignForm.fields.map((room, i) => (
          <Controller
            key={room.id}
            name={`assign.${i}.remoteDeviceId`}
            control={control}
            render={({ field: { onChange, value } }) => (
              <TableRow css={css({ '> div': { fontWeight: 500 } })}>
                <div css={roomTypeWidthStyle}>
                  {assignForm.fields[i].typeNameJa === assignForm.fields[i - 1]?.typeNameJa ? '' : assignForm.fields[i].typeNameJa}
                </div>
                <div css={floorNumberWidthStyle}>{room.floorNameJa}</div>
                <div css={roomNameWidthStyle}>{room.roomNumber}</div>
                <div css={deviceNameWidthStyle}>
                  <Select
                    value={deviceList?.length ? value : ''}
                    onChange={selectVal => {
                      onChange(selectVal)
                      parentOnChange()
                    }}
                    customStyle={css({ paddingBottom: 0, width: 263 })}
                  >
                    <AntSelect.Option value="">-</AntSelect.Option>
                    {deviceList?.map(device => (
                      <AntSelect.Option key={device.id} value={device.id}>
                        {device.name}
                      </AntSelect.Option>
                    ))}
                  </Select>
                </div>
              </TableRow>
            )}
          />
        ))}
      </TableBody>
    </>
  )
}

const roomTypeWidthStyle = css({ width: '20%', paddingLeft: 32 })
const floorNumberWidthStyle = css({ width: '10%' })
const roomNameWidthStyle = css({ width: '15%' })
const deviceNameWidthStyle = css({ width: '55%' })
